module.exports = __webpack_public_path__ + "img/56.maintenance_problem.1860caa4.svg";